module.exports = __webpack_public_path__ + "media/images/footer_contact-9f4be9550d07a204d2c8b676db4ff064.svg";